import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  COMPANY_DISEASES,
  COMPANY_STRUCTURE,
  GAMIFICATION_ACHIEVEMENT,
  GAMIFICATION_ACHIEVEMENTS,
  GAMIFICATION_REDEMPTION_ITEM_HISTORY,
  GAMIFICATION_REDEMPTION_ITEM_UPDATE,
  GAMIFICATION_REDEMPTION_LIST,
  GAMIFICATION_SHOP_ITEM,
  GAMIFICATION_SHOP_ITEMS,
  GAMIFICATION_TASK,
  GAMIFICATION_TASKS,
  GET_BILLING_BATCH_LIST,
  GET_BILLING_INVOICE,
  GET_BILLING_INVOICE_DETAILS,
  START_BILLING,
  UNBILL_INVOICE
} from 'src/constants'

export default {
  getCompanyStructure(query) {
    return httpClient.get({
      pathname: COMPANY_STRUCTURE,
      query
    })
  },
  getCompanyDiseases(query) {
    return httpClient.get({
      pathname: COMPANY_DISEASES,
      query
    })
  },
  getCompanyAchievementsList(config = {}) {
    const { params, query } = config
    return httpClient.get({
      pathname: GAMIFICATION_ACHIEVEMENTS,
      params,
      query
    })
  },
  updateAchievement(config = {}) {
    const { params, query, payload } = config
    return httpClient.patch(
      {
        pathname: GAMIFICATION_ACHIEVEMENT,
        params,
        query
      },
      payload
    )
  },
  getCompanyTasksList(config = {}) {
    const { params, query } = config
    return httpClient.get({
      pathname: GAMIFICATION_TASKS,
      params,
      query
    })
  },
  updateTask(config = {}) {
    const { params, query, payload } = config
    return httpClient.patch(
      {
        pathname: GAMIFICATION_TASK,
        params,
        query
      },
      payload
    )
  },
  getCompanyShopItemsList(config = {}) {
    const { params, query } = config
    return httpClient.get({
      pathname: GAMIFICATION_SHOP_ITEMS,
      params,
      query
    })
  },
  updateShopItem(config = {}) {
    const { params, query, payload } = config
    return httpClient.patch(
      {
        pathname: GAMIFICATION_SHOP_ITEM,
        params,
        query
      },
      payload
    )
  },
  getCompanyGamificationRedemptionList(config = {}) {
    const { params, query } = config
    return httpClient.get({
      pathname: GAMIFICATION_REDEMPTION_LIST,
      params,
      query
    })
  },
  updateRedemptionItemStatus(config = {}) {
    const { params, query, payload } = config
    return httpClient.patch(
      {
        pathname: GAMIFICATION_REDEMPTION_ITEM_UPDATE,
        params,
        query
      },
      payload
    )
  },
  async getRedemptionItemHistory(config = {}) {
    const { params, query } = config
    try {
      const response = await httpClient.get({
        pathname: GAMIFICATION_REDEMPTION_ITEM_HISTORY,
        params,
        query
      })
      return response
    } catch (err) {
      catchError(err)
      throw err
    }
  },
  postNewBillingBatch(payload) {
    return httpClient.post(
      {
        pathname: START_BILLING
      },
      payload
    )
  },
  getBillingBatch(config = {}) {
    const { params = {}, query = {} } = config
    return httpClient.get({
      pathname: GET_BILLING_BATCH_LIST,
      params,
      query
    })
  },
  getBatchInvoice(config = {}) {
    const { params = {}, query = {} } = config
    return httpClient.get({
      pathname: GET_BILLING_INVOICE,
      params,
      query
    })
  },
  getBillingInvoiceDetails(config = {}) {
    const { params = {}, query = {} } = config
    return httpClient.get({
      pathname: GET_BILLING_INVOICE_DETAILS,
      params,
      query
    })
  },
  unbillInvoice(config = {}) {
    const { params = {}, query = {} } = config
    return httpClient.post({
      pathname: UNBILL_INVOICE,
      params,
      query
    })
  }
}
